import styled from 'styled-components';

export const StyledFilters = styled.div``;
export const StyledSearch = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledHeader = styled.header`
  display: flex;
  align-items: center;

  & ${StyledSearch} {
    margin-left: auto;
    width: 20%;
  }
`;
